const COMMENT_ITEMS = [
  {
    name: '影迷小陈',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20male%20avatar%20portrait%2C%20casual%20style%2C%20warm%20lighting%2C%20friendly%20expression%2C%20clean%20background%2C%20professional%20headshot%20style&width=80&height=80&seq=avatar-01&orientation=squarish',
    time: '2 小时前',
    content: '用了榴莲视频快两年了，资源更新真的快，而且画质很清晰。之前在其他平台看经常缓冲，这里体验好太多了，推荐给身边很多朋友了！',
    likes: 326,
  },
  {
    name: '追剧达人',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20female%20avatar%20portrait%2C%20modern%20style%2C%20warm%20lighting%2C%20gentle%20smile%2C%20clean%20background%2C%20professional%20headshot%20style&width=80&height=80&seq=avatar-02&orientation=squarish',
    time: '5 小时前',
    content: '分类特别全，从影视到综艺再到动漫都有。每天中午休息的时候就刷一刷，已经成为日常习惯了。希望能一直保持这个更新频率！',
    likes: 218,
  },
  {
    name: '深夜放映室',
    avatar: 'https://readdy.ai/api/search-image?query=Mature%20Asian%20male%20avatar%20portrait%2C%20casual%20cool%20style%2C%20warm%20lighting%2C%20confident%20expression%2C%20clean%20background%2C%20professional%20headshot%20style&width=80&height=80&seq=avatar-03&orientation=squarish',
    time: '昨天 23:42',
    content: '最大的感受就是方便，不用注册直接看，也不用装乱七八糟的播放器。APP 离线缓存功能简直出差神器，飞机高铁上也能看。',
    likes: 157,
  },
  {
    name: '樱花飘落',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20female%20avatar%20portrait%2C%20elegant%20style%2C%20warm%20lighting%2C%20bright%20smile%2C%20clean%20background%2C%20professional%20headshot%20style&width=80&height=80&seq=avatar-04&orientation=squarish',
    time: '昨天 18:15',
    content: '偶然发现这个宝藏平台，界面干净没广告弹窗，观影体验很纯粹。已经安利给整个宿舍的姐妹了，大家都很喜欢！',
    likes: 203,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-24 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
            <i className="ri-chat-3-line text-sm"></i>
            用户反馈
          </div>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
            听听他们怎么说
          </h2>
          <p className="text-sm text-foreground-600 mt-2 max-w-md mx-auto">
            来自真实用户的使用体验分享
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {COMMENT_ITEMS.map((item, idx) => (
            <div
              key={idx}
              className="p-5 rounded-2xl bg-background-100 border border-background-200/60"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden shrink-0">
                  <img src={item.avatar} alt={item.name} className="w-full h-full object-cover" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-medium text-foreground-950 text-sm">{item.name}</div>
                  <div className="text-xs text-foreground-500">{item.time}</div>
                </div>
                <div className="flex items-center gap-1 text-foreground-500 text-xs">
                  <i className="ri-heart-line"></i>
                  <span>{item.likes}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed">{item.content}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}